/**
 * WalkAndPunch API
 * This is the WalkAndPunch API
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient, HttpHeaders, HttpParams,
  HttpResponse, HttpEvent
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { AvailableColumnViewModel } from '../model/availableColumnViewModel';
import { MasterViewModel } from '../model/masterViewModel';
import { ReportAddCustomReportQueueBody } from '../model/reportAddCustomReportQueueBody';
import { ReportSaveCustomReportBody } from '../model/reportSaveCustomReportBody';
import { SaveCustomReportViewModel } from '../model/saveCustomReportViewModel';
import { TemplateIdProjectIdViewModel } from '../model/templateIdProjectIdViewModel';
import { TemplateProjectCustomReportSourceViewModel } from '../model/templateProjectCustomReportSourceViewModel';
import { TemplateProjectCustomReportViewModel } from '../model/templateProjectCustomReportViewModel';

import { BASE_PATH } from '../variables';
import { Configuration } from '../configuration';


@Injectable()
export class ReportService {

  protected basePath = '/';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }


  /**
   *
   *
   * @param body
   * @param templateProjectCustomReportId
   * @param timezone
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public addCustomReportQueue(body?: ReportAddCustomReportQueueBody, templateProjectCustomReportId?: number, timezone?: string, observe?: 'body', reportProgress?: boolean): Observable<number>;
  public addCustomReportQueue(body?: ReportAddCustomReportQueueBody, templateProjectCustomReportId?: number, timezone?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
  public addCustomReportQueue(body?: ReportAddCustomReportQueueBody, templateProjectCustomReportId?: number, timezone?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
  public addCustomReportQueue(body?: ReportAddCustomReportQueueBody, templateProjectCustomReportId?: number, timezone?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {




    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    if (templateProjectCustomReportId !== undefined && templateProjectCustomReportId !== null) {
      queryParameters = queryParameters.set('templateProjectCustomReportId', <any>templateProjectCustomReportId);
    }
    if (timezone !== undefined && timezone !== null) {
      queryParameters = queryParameters.set('timezone', <any>timezone);
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json-patch+json',
      'application/json',
      'text/json',
      'application/_*+json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<number>('post', `${this.basePath}/v1/Report/AddCustomReportQueue`,
      {
        body: body,
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param templateProjectCustomReportId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteCustomReport(templateProjectCustomReportId?: number, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
  public deleteCustomReport(templateProjectCustomReportId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
  public deleteCustomReport(templateProjectCustomReportId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
  public deleteCustomReport(templateProjectCustomReportId?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    if (templateProjectCustomReportId !== undefined && templateProjectCustomReportId !== null) {
      queryParameters = queryParameters.set('templateProjectCustomReportId', <any>templateProjectCustomReportId);
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
    ];

    return this.httpClient.request<boolean>('delete', `${this.basePath}/v1/Report/CustomReport`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param body
   * @param sourceId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAvailableColumnsBySource(body?: Array<string>, sourceId?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<AvailableColumnViewModel>>;
  public getAvailableColumnsBySource(body?: Array<string>, sourceId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AvailableColumnViewModel>>>;
  public getAvailableColumnsBySource(body?: Array<string>, sourceId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AvailableColumnViewModel>>>;
  public getAvailableColumnsBySource(body?: Array<string>, sourceId?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {



    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    if (sourceId !== undefined && sourceId !== null) {
      queryParameters = queryParameters.set('sourceId', <any>sourceId);
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json-patch+json',
      'application/json',
      'text/json',
      'application/_*+json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<Array<AvailableColumnViewModel>>('post', `${this.basePath}/v1/Report/customReportColumnsBySource`,
      {
        body: body,
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAvailableCustomReportSources(body?: Array<TemplateIdProjectIdViewModel>, observe?: 'body', reportProgress?: boolean): Observable<Array<TemplateProjectCustomReportSourceViewModel>>;
  public getAvailableCustomReportSources(body?: Array<TemplateIdProjectIdViewModel>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TemplateProjectCustomReportSourceViewModel>>>;
  public getAvailableCustomReportSources(body?: Array<TemplateIdProjectIdViewModel>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TemplateProjectCustomReportSourceViewModel>>>;
  public getAvailableCustomReportSources(body?: Array<TemplateIdProjectIdViewModel>, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json-patch+json',
      'application/json',
      'text/json',
      'application/_*+json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<Array<TemplateProjectCustomReportSourceViewModel>>('post', `${this.basePath}/v1/Report/GetCustomReportSources`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param templateProjectCustomReportId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCustomReportForUpdate(templateProjectCustomReportId?: number, observe?: 'body', reportProgress?: boolean): Observable<SaveCustomReportViewModel>;
  public getCustomReportForUpdate(templateProjectCustomReportId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SaveCustomReportViewModel>>;
  public getCustomReportForUpdate(templateProjectCustomReportId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SaveCustomReportViewModel>>;
  public getCustomReportForUpdate(templateProjectCustomReportId?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    if (templateProjectCustomReportId !== undefined && templateProjectCustomReportId !== null) {
      queryParameters = queryParameters.set('templateProjectCustomReportId', <any>templateProjectCustomReportId);
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
    ];

    return this.httpClient.request<SaveCustomReportViewModel>('get', `${this.basePath}/v1/Report/CustomReportForUpdate`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCustomReports(observe?: 'body', reportProgress?: boolean): Observable<Array<TemplateProjectCustomReportViewModel>>;
  public getCustomReports(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TemplateProjectCustomReportViewModel>>>;
  public getCustomReports(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TemplateProjectCustomReportViewModel>>>;
  public getCustomReports(observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
    ];

    return this.httpClient.request<Array<TemplateProjectCustomReportViewModel>>('get', `${this.basePath}/v1/Report/CustomReports`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCustomReportsByProjectTemplate(observe?: 'body', reportProgress?: boolean): Observable<Array<TemplateProjectCustomReportViewModel>>;
  public getCustomReportsByProjectTemplate(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TemplateProjectCustomReportViewModel>>>;
  public getCustomReportsByProjectTemplate(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TemplateProjectCustomReportViewModel>>>;
  public getCustomReportsByProjectTemplate(observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
    ];

    return this.httpClient.request<Array<TemplateProjectCustomReportViewModel>>('get', `${this.basePath}/v1/Report/CustomReportsByProjectTemplate`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCustomReportsForUserRole(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterViewModel>>;
  public getCustomReportsForUserRole(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterViewModel>>>;
  public getCustomReportsForUserRole(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterViewModel>>>;
  public getCustomReportsForUserRole(observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
    ];

    return this.httpClient.request<Array<MasterViewModel>>('get', `${this.basePath}/v1/Report/CustomReportsForUserRole`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public saveCustomReport(body?: ReportSaveCustomReportBody, observe?: 'body', reportProgress?: boolean): Observable<number>;
  public saveCustomReport(body?: ReportSaveCustomReportBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
  public saveCustomReport(body?: ReportSaveCustomReportBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
  public saveCustomReport(body?: ReportSaveCustomReportBody, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json-patch+json',
      'application/json',
      'text/json',
      'application/_*+json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<number>('post', `${this.basePath}/v1/Report/saveCustomReport`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

}
